import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Contato from './pages/Contato';
import Calendario from './pages/interno/Calendario';
import Urgencia from './pages/servicos/Urgencia';
import PaineisMonitoramento from './pages/interno/PaineisMonitoramento';
import Hub from './pages/interno/Hub';
import Forms from './pages/interno/Forms';
import Notify from './pages/interno/Notify';
import Login from './pages/Login';
import CalendarioExterno from './pages/Agenda';
import Blog from './pages/Blog';
import SaudeMental from './pages/servicos/SaudeMental';
import Seguranca from './pages/servicos/Seguranca';
import Maternidade from './pages/servicos/Maternidade';
import CCIH from './pages/servicos/CCIH';
import Hospitais from './pages/servicos/Hospitais';
import Assessoria from './pages/servicos/Assessoria';
import Boletins from './pages/servicos/Boletins';
import Plataforma from './pages/servicos/Plataforma';
import Atendimento from './pages/servicos/Atendimento';
import Guias from './pages/servicos/Guias';
import Cegonha from './pages/servicos/Cegonha';
import Ouvidoria from './pages/servicos/Ouvidoria';
import Register from './pages/Register';
import NotesLogin from './pages/NotesLogin';
import AdminVisualize from './pages/interno/administrador/AdminVisualize';
import Permissionador from './pages/interno/administrador/Permissionador';
import CalendarForm from './pages/interno/CalendarForm';
import Monitoramento from './pages/interno/Monitoramento';
import NotifyForm from './components/NotifyForm';
import NotifyHub from './pages/servicos/NotesHub';
import NotesAvaliation from './pages/interno/NotesAvaliation';
import ClassInvForm from './components/ClassInvForm';
import { requestUnits, requestPublics } from '../src/services/requests';

import Cadastro from './pages/interno/administrador/Cadastro';
import BlogCardExpand from './components/BlogCardExpand';
import BlogShortcut from './components/BlogShortcut';
import CryptoJS from 'crypto-js';

function App() {
	const [isLoading, setIsLoading] = useState(true);
	const location = useLocation();
	const [unidades, setUnidades] = useState([]);
	const [publics, setPublics] = useState([]);
	const secret = process.env.REACT_APP_SECRET;

	const request = async () => {
		const requestLog = await requestUnits();
		const requestPubs = await requestPublics();
		if (requestPubs) {
			setPublics(requestPubs);
		}
		if (requestLog) {
			setUnidades(requestLog);
		}
	};

	const encryptName = (name) => {
		const encoded = btoa(name);
		return encoded;
	};

	useEffect(() => {
		request();
		setIsLoading(true);
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 1000);

		return () => clearTimeout(timer);
	}, [location.pathname]);

	return (
		<div className='w-full max-w-full overflow-x-hidden'>
			{' '}
			{isLoading ? (
				<div className='loader'>
					<div
						className='flex justify-center h-[1200px] content-center align-bottom items-baseline  w-full my-20'
						role='status'>
						<svg
							aria-hidden='true'
							className='w-8 h-8 text-gray-200 animate-spin mt-[100px]  fill-blue-600'
							viewBox='0 0 100 101'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'>
							<path
								d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
								fill='currentColor'
							/>
							<path
								d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
								fill='currentFill'
							/>
						</svg>
						<span className='sr-only'>Loading...</span>
					</div>
				</div>
			) : (
				<Routes>
					<Route
						path='/'
						element={<Navigate to='/home' />}
					/>
					<Route
						path='home'
						element={<Home />}
					/>
					<Route
						path='agenda-eventos'
						element={<CalendarioExterno />}
					/>
					<Route
						path='contato'
						element={<Contato />}
					/>
					<Route
						path='calendario-interno'
						element={<Calendario />}
					/>
					<Route
						path='login'
						element={<Login />}
					/>
					<Route
						path='paineis-de-monitoramento'
						element={<PaineisMonitoramento />}
					/>
					<Route
						path='hub'
						element={<Hub />}
					/>
					<Route
						path='escala'
						element={<Forms />}
					/>
					<Route
						path='notificacoes'
						element={<Notify />}
					/>
					<Route
						path='register'
						element={<Register />}
					/>
					<Route
						path='cadastro'
						element={<Cadastro />}
					/>
					<Route
						path={'/assessoria-de-programas-de-desospitalizacao'}
						element={<Assessoria />}
					/>
					<Route
						path={'/seguranca-do-paciente'}
						element={<Seguranca />}
					/>
					<Route
						path={'/urgencia-e-emergencia'}
						element={<Urgencia />}
					/>
					<Route
						path={'/saude-mental'}
						element={<SaudeMental />}
					/>
					<Route
						path={'/maternidade-e-pediatria'}
						element={<Maternidade />}
					/>
					<Route
						path={'/ccih'}
						element={<CCIH />}
					/>
					<Route
						path='/hospitais-gerais-especializados'
						element={<Hospitais />}
					/>
					<Route
						path={'/boletins-informativos'}
						element={<Boletins />}
					/>
					<Route
						path={'/plataforma-de-ensino'}
						element={<Plataforma />}
					/>
					<Route
						path={'/atendimento'}
						element={<Atendimento />}
					/>
					<Route
						path={'/guias'}
						element={<Guias />}
					/>
					<Route
						path={'/monitoramento-leitos'}
						element={<Monitoramento />}
					/>
					<Route
						path={'/cegonha'}
						element={<Cegonha />}
					/>
					<Route
						path={'/ouvidoria'}
						element={<Ouvidoria />}
					/>
					<Route
						path={'/notificacoes-login'}
						element={<NotesLogin />}
					/>
					<Route
						path={'/admin-visualize'}
						element={<AdminVisualize />}
					/>
					<Route
						path={'/permissionador'}
						element={<Permissionador />}
					/>
					<Route
						path={'/blog'}
						element={<Blog />}
					/>
					<Route
						path={'/calendar-form'}
						element={<CalendarForm />}
					/>
					<Route
						path={'/hub-de-notificacoes'}
						element={<NotifyHub />}
					/>
					<Route
						path={'/notifyform'}
						element={<NotifyForm />}
					/>
					<Route
						path={'/notes-avaliation'}
						element={<NotesAvaliation />}
					/>
					<Route
						path={'/class-inv-form'}
						element={<ClassInvForm />}
					/>
					{/* Rotas dinâmicas geradas via map */}
					{publics && publics.length > 0 ? (
						publics.map((pub) => (
							<Route
								key={'blog' + pub.id}
								path={`/blog/${pub.id}`}
								element={<Blog />}
							/>
						))
					) : (
						<Route
							path='/blog/nenhuma noticia disponível'
							element={<div>Nenhuma noticia com esta url.</div>}
						/>
					)}

					{/* Rotas dinâmicas geradas via map */}
					{/* {unidades && unidades.length > 0 ? (
						unidades.map((unidade) => (
							<Route
								key={unidade.id + 11}
								path={`/notificacoes/${unidade.nome
									.toLowerCase()
									.replace(/\s+/g, '-')}`}
								element={<Notify />}
							/>
						))
					) : (
						<Route
							path='/notificacoes/nenhuma-unidade'
							element={<div>Nenhuma unidade disponível.</div>}
						/>
					)} */}

					{/* Rotas dinâmicas geradas via map */}
					{unidades && unidades.length > 0 ? (
						unidades.map((unidade) => (
							<Route
								key={unidade.id + 'tonc'}
								path={`/notificacoes/${encryptName(
									unidade.nome,
									secret
								)}`}
								element={<Notify />}
							/>
						))
					) : (
						<Route
							path='/notificacoes/nenhuma-notificacao'
							element={<div>Nenhuma noificação disponível.</div>}
						/>
					)}
				</Routes>
			)}
		</div>
	);
}
export default App;
